<template>
    <div class="open-positions-card">
      <div class="card">
        <div class="card-body">
          <div class="card-title placeholder-glow mb-5">
            <span class="placeholder col-12"></span>
          </div>
          <div class="card-text placeholder-glow">
            <span class="placeholder col-7"></span>
            <span class="placeholder col-4"></span>
            <span class="placeholder col-4"></span>
            <span class="placeholder col-6"></span>
            <span class="placeholder col-8"></span>
            <span class="placeholder col-4"></span>
            <span class="placeholder col-4"></span>
            <span class="placeholder col-6"></span>
            <span class="placeholder col-8"></span>
            <span class="placeholder col-4"></span>
            <span class="placeholder col-4"></span>
            <span class="placeholder col-6"></span>
            <span class="placeholder col-4"></span>
            <span class="placeholder col-4"></span>
          </div>
        </div>
      </div>
    </div>
  </template>
  